export const BRIGHTSPACE_URLS = {
    'qa': 'https://talisistest.brightspace.com',
    'production': 'https://campus.talisis.com'
}